import "../post/post.scss";
import { useState, useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { usePostInteractions } from "./hooks/usePostInteractions";
import PostHeader from "./components/PostHeader";
import PostMedia from "./components/PostMedia";
import SharedPost from "./components/SharedPost";
import PostActions from "./components/PostActions";
import Comments from "../comments/Comments";
import Sharepost from "../sharepost/Sharepost";
import PostLinkPreview from "./components/PostLinkPreview";
import ReportModal from "../reportmodal/ReportModal";

const Post = ({ post }) => {
    const [commentOpen, setCommentOpen] = useState(false);
    const [openSharePost, setOpenSharePost] = useState(false);
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const { currentUser } = useContext(AuthContext);

    const { 
        likesCount, 
        commentCount,
        isLiked, 
        isLoadingLikes, 
        isTipping,
        handleLike, 
        handleDelete,
        handleTip,
        getBadgeStyle,
    } = usePostInteractions(post, currentUser);

    const extractUrlFromText = (text) => {
        if (!text) return null;
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const matches = text.match(urlRegex);
        return matches ? matches[0] : null;
    };

    const detectedUrl = post.linkUrl || extractUrlFromText(post.desc);

    const previewDataObj = (post.linkTitle || post.linkImg) ? {
        title: post.linkTitle,
        description: post.linkDesc,
        img: post.linkImg,
        url: post.linkUrl
    } : null;

    return (
        <div className="post">
            <div className="container">
                <PostHeader 
                    post={post} 
                    isOwner={post.userId === currentUser.id} 
                    onDelete={handleDelete} 
                    onReport={() => setReportModalOpen(true)}
                />

                <div className="content">
                    <div className="badge" style={getBadgeStyle(post.type)}>
                        {post.type || "Discussion"}
                    </div>

                    <p>
                        {post.desc}
                    </p>

                    {detectedUrl && (
                        <PostLinkPreview 
                            previewData={previewDataObj} 
                            url={detectedUrl} 
                        />
                    )}
                    
                    {post.originalPostId ? (
                        <SharedPost post={post} />
                    ) : (
                        <PostMedia images={post.img} postId={post.id} />
                    )}
                </div>

                <PostActions 
                    isLiked={isLiked}
                    likeCount={likesCount}
                    isLoading={isLoadingLikes}
                    isTipping={isTipping}
                    hasWallet={!!post.walletAddress} 
                    onLike={handleLike}
                    onCommentClick={() => setCommentOpen(!commentOpen)}
                    onShareClick={() => setOpenSharePost(true)}
                    commentCount={commentCount}
                />

                {commentOpen && <Comments postId={post.id} />}
                
                {openSharePost && <Sharepost setOpenShare={setOpenSharePost} postToShare={post} />}
            
                <ReportModal 
                    isOpen={reportModalOpen} 
                    onClose={() => setReportModalOpen(false)} 
                    targetId={post.id} 
                    targetType="POST" 
                />
            </div>
        </div>
    );
};

export default Post;